<div id="appHeaderWrapper" class="app-header-wrapper" #content="pwContent" pwContent>
  <div id="primaryCTAWrapperExp" *ngIf="($isFailure | async) === false">
    <div *ngIf="router.url.includes('rebalancing-your-portfolio')" class="rebalancing-your-portfolio-header phc-header">
      <div>
        <a c11n-link tabindex="0" (click)="navigateToPortfolioHealthCheckPage()"
          (keyup.enter)="navigateToPortfolioHealthCheckPage()" [iconName]="'link-left'" [iconPosition]="'leading'">
          Go back to overview
        </a>
      </div>
      <div class="tools-section-exp-wrapper">
        <ng-template [ngTemplateOutlet]="toolsSectionPHC"></ng-template>
      </div>
    </div>

    <div *ngIf="!router.url.includes('rebalancing-your-portfolio') && !router.url.includes('no-goals')" class="tools-section-exp-wrapper phc-header">
      <ng-template [ngTemplateOutlet]="toolsSectionPHC"></ng-template>
    </div>
  </div>

  <ng-template #toolsSectionPHC>
    <div id="headerToolsSectionPHC" class="tools-section-phc phc-header">
      <div class="tools-section-phc--hidden" *ngIf="!router.url.includes('rebalancing-your-portfolio')"></div>
      <a c11n-link id="printLink" target="_blank" tabindex="0" (click)="print(); printLinkClicked.emit(defaultData)"
        [variant]="'secondary-independent'" [fontWeight]="'normal'"
        (keyup.enter)="print(); printLinkClicked.emit(defaultData)" class="button-cta">{{ content['PWOverview_Print'] |
        getFromAEM }}
      </a>
      <a c11n-link id="pageHelpLink" tabindex="0" (click)="openPageHelpDrawer('aboutPortfolioWatch')"
        [variant]="'secondary-independent'" [fontWeight]="'normal'"
        (keyup.enter)="openPageHelpDrawer('aboutPortfolioWatch')"
        [attr.aria-label]="content['PWOverview_Help'] | getFromAEM" [iconName]="'help'" class="button-cta">{{
        content['PWOverview_Help'] | getFromAEM }}
      </a>
    </div>
  </ng-template>
</div>
